// Mock data for reviviz device repair service - Czech version

export const businessInfo = {
  name: "reviviz",
  tagline: "Vdechněte svým zařízením nový život",
  phone: "+420 722 337 342",
  email: "info@reviviz.cz",
  address: "Hybešova 200/6, 779 00 Olomouc",
  hours: "Po–Pá 9:00–18:00",
  logoUrl: `${process.env.PUBLIC_URL}/logo-reviviz.png`,
  logoDarkUrl: `${process.env.PUBLIC_URL}/logo-reviviz-dark.png`,
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2607.0!2d17.2508!3d49.5938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4713c6e8f3f3f3f3%3A0x0!2sHybe%C5%A1ova%20200%2F6%2C%20779%2000%20Olomouc!5e0!3m2!1scs!2scz!4v1234567890",
  mapEmbedSrc: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2607.5!2d17.2508!3d49.5938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47124e8c9f2a5c5d%3A0x8c0c4e7c6f0e9a8b!2sHybe%C5%A1ova%20200%2F6%2C%20779%2000%20Olomouc%209!5e0!3m2!1scs!2scz!4v1704067200000!5m2!1scs!2scz"
};

export const services = [
  {
    id: 1,
    title: "Oprava mobilních telefonů",
    description: "Výměna displejů, baterií, nabíjecích portů a další. Opravujeme všechny značky smartphonů.",
    icon: "Smartphone"
  },
  {
    id: 2,
    title: "Oprava notebooků a laptopů",
    description: "Od hardwarových závad po softwarové problémy – diagnostikujeme a opravíme vše.",
    icon: "Laptop"
  },
  {
    id: 3,
    title: "Oprava elektroniky",
    description: "Diagnostika a opravy nízkonapěťové elektroniky. Tablety, herní konzole a další.",
    icon: "Cpu"
  },
  {
    id: 4,
    title: "Čištění a údržba",
    description: "Hloubkové čištění, výměna teplovodivé pasty a refresh zařízení pro prodloužení životnosti.",
    icon: "Sparkles"
  },
  {
    id: 5,
    title: "Upgrady a aktualizace",
    description: "Rozšíření RAM, instalace SSD, aktualizace softwaru a optimalizace výkonu.",
    icon: "ArrowUpCircle"
  }
];

export const howItWorks = [
  {
    step: 1,
    title: "Kontaktujte nás",
    description: "Ozvěte se nám přes webový formulář, e-mail nebo telefon. Můžete přiložit fotografie vašeho zařízení."
  },
  {
    step: 2,
    title: "Přineste zařízení",
    description: "Doručte své zařízení k nám na pobočku pro důkladnou diagnostiku."
  },
  {
    step: 3,
    title: "Bezplatná diagnostika",
    description: "Diagnostikujeme problém zcela zdarma. Žádné skryté poplatky, žádné závazky."
  },
  {
    step: 4,
    title: "Získejte cenovou nabídku",
    description: "Obdržíte transparentní cenu opravy a odhadovaný čas dokončení před zahájením práce."
  }
];

export const trustPoints = [
  {
    id: 1,
    title: "Diagnostika zdarma",
    description: "Každá diagnostika je zcela zdarma. Víte přesně, co je v nepořádku, než se rozhodnete.",
    icon: "BadgeCheck"
  },
  {
    id: 2,
    title: "Transparentní ceny",
    description: "Žádná překvapení. Přesnou cenu znáte ještě před zahájením jakékoli opravy.",
    icon: "Receipt"
  },
  {
    id: 3,
    title: "Jasné termíny",
    description: "Poskytujeme realistické odhady času, abyste se mohli podle toho zařídit.",
    icon: "Clock"
  },
  {
    id: 4,
    title: "Zkušení technici",
    description: "Kvalifikovaní odborníci s dlouholetými zkušenostmi v opravách zařízení.",
    icon: "Wrench"
  }
];

export const deviceTypes = [
  "Mobilní telefon",
  "Notebook / Laptop",
  "Tablet",
  "Herní zařízení",
  "Jiná elektronika"
];

export const translations = {
  nav: {
    services: "Služby",
    howItWorks: "Jak to funguje",
    whyUs: "Proč reviviz",
    contact: "Kontakt",
    freeDiagnostics: "Diagnostika zdarma"
  },
  hero: {
    badge: "Diagnostika zdarma • Vždy",
    headline1: "Rychlé a spolehlivé",
    headline2: "opravy zařízení",
    subheadline: "Profesionální diagnostika a opravy mobilních telefonů, notebooků a elektroniky.",
    diagnosticsFree: "Diagnostika vždy zdarma.",
    trustPoints: ["Diagnostika zdarma", "Transparentní ceny", "Rychlé vyřízení"],
    ctaPrimary: "Objednat diagnostiku zdarma",
    ctaCall: "Zavolat",
    ctaEmail: "E-mail",
    priceEstimate: "Cenová nabídka",
    transparent: "Transparentní",
    diagnosticsCost: "Cena diagnostiky",
    free: "ZDARMA"
  },
  services: {
    label: "Naše služby",
    title: "Profesionální opravy všech zařízení",
    description: "Od smartphonů po notebooky – poskytujeme profesionální diagnostiku a opravy s transparentními cenami.",
    freeDiagnosticsTitle: "Diagnostika zdarma",
    freeDiagnosticsDesc: "Každá diagnostika zařízení je zcela zdarma. Víte přesně, co je v nepořádku, než se k čemukoli zavážete.",
    alwaysFree: "Vždy ZDARMA"
  },
  howItWorks: {
    label: "Jednoduchý proces",
    title: "Jak to funguje",
    description: "Oprava vašeho zařízení je jednoduchá. Čtyři snadné kroky k tomu, abyste byli opět v provozu.",
    costLabel: "Cena: 0 Kč"
  },
  whyUs: {
    label: "Proč si vybrat nás",
    title: "Proč reviviz?",
    description: "Věříme v poctivý a transparentní servis. Proto je diagnostika vždy zdarma a nikdy se nesetkáte se skrytými poplatky.",
    stats: {
      diagnosticsCost: "Cena diagnostiky",
      alwaysFree: "Vždy ZDARMA",
      transparentPricing: "Transparentní ceny",
      noHiddenFees: "Bez skrytých poplatků",
      turnaround: "Doba vyřízení",
      clearEstimates: "Jasné odhady",
      expertTeam: "Odborný tým",
      skilledTechnicians: "Zkušení technici"
    },
    guarantee: "Záruka diagnostiky zdarma",
    guaranteeDesc: "Každá diagnostika je 100% zdarma, bez jakýchkoli závazků."
  },
  contact: {
    label: "Kontaktujte nás",
    title: "Objednejte diagnostiku zdarma",
    description: "Vyplňte formulář, pošlete nám e-mail nebo zavolejte. Diagnostikujeme vaše zařízení zcela zdarma a poskytneme vám transparentní cenovou nabídku.",
    callUs: "Zavolejte nám",
    emailUs: "Napište nám",
    visitUs: "Navštivte nás",
    openingHours: "Otevírací doba",
    freeDiagnostics: "Diagnostika zdarma",
    freeDiagnosticsDesc: "Vždy zdarma, bez závazků",
    form: {
      title: "Pošlete nám detaily o vašem zařízení",
      subtitle: "Přiložte fotografie pro rychlejší diagnostiku",
      name: "Vaše jméno *",
      namePlaceholder: "Jan Novák",
      email: "E-mail",
      emailPlaceholder: "vas@email.cz",
      phone: "Telefon",
      phonePlaceholder: "+420 XXX XXX XXX",
      deviceType: "Typ zařízení *",
      deviceTypePlaceholder: "Vyberte typ zařízení",
      description: "Popište problém *",
      descriptionPlaceholder: "Řekněte nám, co je s vaším zařízením v nepořádku...",
      attachPhotos: "Přiložit fotografie (volitelné)",
      uploadText: "Klikněte pro nahrání fotografií",
      uploadHint: "Max 5 obrázků, každý do 10 MB",
      submit: "Objednat diagnostiku zdarma",
      sending: "Odesílání...",
      freeNote: "Diagnostika je vždy",
      freeHighlight: "ZDARMA",
      noCommitment: ". Bez závazků."
    },
    success: {
      title: "Požadavek odeslán!",
      message: "Děkujeme za váš zájem. Ozveme se vám do 24 hodin."
    },
    errors: {
      nameRequired: "Jméno je povinné",
      contactRequired: "Zadejte prosím e-mail nebo telefonní číslo",
      invalidEmail: "Neplatný formát e-mailu",
      deviceTypeRequired: "Vyberte prosím typ zařízení",
      descriptionRequired: "Popište prosím problém"
    },
    map: {
      title: "Kde nás najdete"
    }
  },
  footer: {
    description: "Profesionální diagnostika a opravy mobilních telefonů, notebooků a nízkonapěťové elektroniky. Diagnostika zdarma, transparentní ceny a rychlé vyřízení.",
    badge: "Diagnostika zdarma • Vždy",
    quickLinks: "Rychlé odkazy",
    contact: "Kontakt",
    copyright: "Všechna práva vyhrazena.",
    diagnosticsFree: "Diagnostika: ZDARMA",
    transparentPricing: "Transparentní ceny",
    fastTurnaround: "Rychlé vyřízení"
  }
};
